/* unplugin-vue-components disabled */import script from "./MdEditorCoverUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MdEditorCoverUploader.vue?vue&type=script&setup=true&lang=ts"

import "./MdEditorCoverUploader.vue?vue&type=style&index=0&id=5e68dbfa&lang=scss&scoped=true"
import "./MdEditorCoverUploader.vue?vue&type=style&index=1&id=5e68dbfa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e68dbfa"]])

export default __exports__